import React from "react";
import { useDispatch, useSelector } from "react-redux";
import UserImg from "./UserImg";
import { API_URL } from "../config/app-config";
import moment from "moment";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router";
import { setSelectedUserAction } from "../redux/actions/chatActions";
import { removeGroupOfNotificationById } from "../redux/actions/notificationActions";
import ProfileService from "../api/ProfileService";

const notifications = [
  { id: 1, message: "New message from John", time: "2m ago" },
  { id: 2, message: "Your order has been shipped", time: "10m ago" },
  { id: 3, message: "Reminder: Meeting at 3 PM", time: "30m ago" },
  { id: 4, message: "New comment on your post", time: "1h ago" },
  { id: 5, message: "Anna liked your photo", time: "2h ago" },
  { id: 6, message: "Your password was changed", time: "3h ago" },
  { id: 7, message: "Event invitation: Team outing", time: "5h ago" },
  { id: 8, message: "New friend request from Mike", time: "6h ago" },
  { id: 9, message: "Security alert: New login attempt", time: "1d ago" },
  { id: 10, message: "Update available for your app", time: "2d ago" },
];

const NotificationV2 = (props) => {
  const { list } = useSelector((state) => state.notification);
  const workspaceType = useSelector(
    (state) => state.loginDetailsApi.loginDetails?.userWorkSpace?.slug
  );
  const dispatch = useDispatch();
  const directNotification = (
    typeid,
    notificationId,
    dashBoardType,
    question_id,
    type,
    data,
    status,
    postDetail
  ) => {
    console.log("totalList profileDetails", postDetail);
    console.log("totalList profileDetails typeid", typeid);
    console.log("totalList profileDetails dashBoardType", dashBoardType);
    console.log("totalList profileDetails status", status);
    console.log("totalList profileDetails status", data);

    var path = "search";

    if (typeid === 9) {
      let username = data.notification ? data.notification.split(" ")[0] : "";
      var userData = {
        userId: data.notificationSenderId,
        userName: username,
        userType: 1,
        profilePhoto: "",
      };
      console.log("userData", userData);
      dispatch(setSelectedUserAction(userData));
      deleteProcess(data);
      // path = `/${workspaceType}/mynetwork`;
      // path = `/friendDescription/${nSenderId}`;
    } else {
      if (dashBoardType === "slot_booking") {
        path = `/my-profile/service`;
      } else if (
        typeid === 3 &&
        (dashBoardType === "public" ||
          dashBoardType === "group" ||
          dashBoardType === "mentor") &&
        status === "calendar"
      ) {
        path = `/${workspaceType}/calendar`;
      } else if (typeid === 3 && dashBoardType === "mentor") {
        path = `/${workspaceType}/calendar`;
      } else if (typeid === 10) {
        if (postDetail) {
          let id = JSON.parse(postDetail);
          // getAdvertisementData(id.postId, id.typeData);
          path = `/${workspaceType}/advertisement/${id.postId}/${id.typeData}`;
        }
      } else if (
        typeid === 3 &&
        (dashBoardType === "post_subscribe" ||
          dashBoardType === "post_subscribe_info" ||
          dashBoardType === "private_post_share" ||
          dashBoardType === "private_post_mention")
      ) {
        if (Object.keys(postDetail).length !== 0) {
          let data = JSON.parse(postDetail);
          path = `/${workspaceType}/userPost/${data.postId}/${data.typeData}`;
        } else {
          path = `/${workspaceType}/home`;
        }
      } else if (
        typeid === 3 &&
        (dashBoardType === "private-forum-community-answer-and-reply-mention" ||
          dashBoardType ===
          "private-forum-community-answer-and-reply-mention" ||
          dashBoardType === "private-forum-community-question-mention" ||
          dashBoardType === "community_subscribe_info")
      ) {
        if (Object.keys(postDetail).length !== 0) {
          let id = JSON.parse(postDetail);
          // if (
          //   dashBoardType == "private-forum-community-answer-and-reply-mention"
          // ) {

          path = `/${workspaceType}/forum-description/${id.postId}/forum-answer/${id?.subjectId} `;
          // } else {
          // path = `/${workspaceType}/forum-community/${
          //   id?.subjectId
          // }/${"sub"}`;
          // }
        } else {
          path = `/${workspaceType}/groupsList`;
        }
      } else if (typeid === 3 && dashBoardType === "groups") {
        if (
          status === "Announcement" &&
          postDetail &&
          !data.notification.includes("A new community has")
        ) {
          path = `/${workspaceType}/calendar`;
        } else if (postDetail) {
          if (Object.keys(postDetail).length !== 0) {
            let id = JSON.parse(postDetail);
            if (id?.communityType === 2) {
              path = `/${workspaceType}/forum-community/${id?.subjectId
                }/${"sub"}`;
            } else {
              path = `/${workspaceType}/groupDescription/${id?.subjectId
                }/${"sub"}`;
            }
          } else {
            path = `/${workspaceType}/groupsList`;
          }
        }
      } else if (postDetail && typeid === 11 && status === "requested") {
        if (Object.keys(postDetail).length !== 0) {
          let id = JSON.parse(postDetail);

          path = `/${workspaceType}/request-dis/${id?.jobId}/${"other-req"}`;
        }
      } else if (postDetail && typeid === 11 && status === "challenge") {
        if (Object.keys(postDetail).length !== 0) {
          let id = JSON.parse(postDetail);

          path = `/${workspaceType}/challengeDescription/${data.referenceId}/${id?.subjectName}`;
        }
      } else if (postDetail && typeid === 11 && status === "Announcement") {
        if (Object.keys(postDetail).length !== 0) {
          let id = JSON.parse(postDetail);

          path = `/${workspaceType}/learning-hub`;
        }
      } else if (postDetail && typeid === 11 && dashBoardType === "resource") {
        if (Object.keys(postDetail).length !== 0) {
          let id = JSON.parse(postDetail);

          path = `/${workspaceType}/learningAppDesription/${data.referenceId}/${id?.subjectName}`;
        }
      } else if (typeid === 3 && dashBoardType === "post_subscribe") {
        path = `/${workspaceType}/home`;
      } else if (typeid === 1 && dashBoardType === "friend_send") {
        if (Object.keys(postDetail).length !== 0) {
          path = `/${workspaceType}/friendDescription/${data.notificationSenderId}`;
        } else {
          path = `/${workspaceType}/mynetwork`;
        }
        // path = `/friendDescription/${nSenderId}`;
      } else if (typeid === 2 && dashBoardType === "friend_accept") {
        path = `/${workspaceType}/friendDescription/${data.notificationSenderId}`;
      } else if (typeid === 3 && type === "instantMeeting") {
        path = `/meeting`;
      } else if (typeid === 5 && dashBoardType === "question") {
        path = `/community/questions/${question_id}`;
      } else if (
        typeid === 5 &&
        (dashBoardType === "answer" || dashBoardType === "answerReply")
      ) {
      } else if (typeid === 5 && dashBoardType === "questionUpvotes") {
        path = `/community/questions/${question_id}`;
      } else if (typeid === 5 && dashBoardType === "upVotesAnswer") {
        path = `/community/questions/${question_id}`;
      } else if (typeid == 4) {
        path = `/${workspaceType}/announcement/${data.referenceId}`;
      } else {
        // sessionStorage.setItem('APP_REDIRECT_PATH', path)
        path = `/${workspaceType}/home`;
        props.history.push(`/redirect`);
      }

      sessionStorage.setItem("APP_REDIRECT_PATH", path);
      props.history.push(`/redirect`);
      if (data) {
        deleteProcess(data);
      }
      // deleteNotification(typeid, notificationId, dashhBoardType, question_id)
    }
  };
  const deleteProcess = (data) => {
    console.log("delete data", data);
    // this.deleteCustomNotification(
    //   [data.notificationId],
    //   [{ notificationId: data.notificationId }],
    //   nothide
    // );
    // dispatch(removeGroupOfNotificationById([data.notificationId], list));
    let deleteNotification = {
      customNotificationId: [data.notificationId],
    };
    ProfileService.custom_delete_notification(deleteNotification)
      .then((response) => {
        dispatch(
          removeGroupOfNotificationById(
            [{ notificationId: data.notificationId }],
            list
          )
        );
      })
      .catch((error) => {
        console.log(error);
      });
  };
  console.log("list", list);

  const clearAllNotifications = () => {
    if (!list || list.length === 0) return;

    const ids = list.map((n) => n.notificationId);

    const deleteNotification = {
      customNotificationId: ids,
    };

    ProfileService.custom_delete_notification(deleteNotification)
      .then((response) => {
        // remove all from redux
        dispatch(removeGroupOfNotificationById(
          ids.map((id) => ({ notificationId: id })),
          list
        ));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className="container mt-4">
      <div className="card shadow-sm">
        <div
          className="card-header  text-white d-flex justify-content-between align-items-center"
          style={{ background: "rgb(21, 40, 60)" }}
        >
          <span>Notifications</span>
          {list && list.length > 0 && (
            <button
              className="btn btn-sm"
              style={{ backgroundColor: "#ffcc00", color: "#ffffffff", borderColor: "#ffcc00" }}
              onClick={clearAllNotifications}
            >
              Clear all
            </button>
          )}
        </div>

        <ul className="list-group list-group-flush">
          {list &&
            list.map((notif) => (
              <li
                style={{ cursor: "pointer" }}
                key={notif.notificationId}
                className="list-group-item d-flex justify-content-between align-items-center"
                onClick={() =>
                  directNotification(
                    notif.notificationType,
                    notif.notificationId,
                    notif.type,
                    notif.referenceId,
                    notif.type,
                    notif,
                    notif.status,
                    notif.data
                  )
                }
              >
                <div
                  className="d-flex align-items-center gap-2"
                  style={{ gap: "1rem" }}
                >
                  <UserImg
                    size="small"
                    imgSrc={
                      API_URL +
                      "api/getUserPhoto/" +
                      notif.notificationSenderId +
                      "/" +
                      "name"
                    }
                    // imgSrc={`${API_URL}auth/image/${nSenderId}`}
                    imgAlt={""}
                    onClickImg={() => { }}
                  />

                  {notif.notification}
                </div>

                <span className="badge badge-secondary badge-pill">
                  {moment(notif.createdDate).locale("en").format("LLL")}
                </span>
              </li>
            ))}
          {list.length === 0 && <p className="p-5">Notification not present</p>}
        </ul>
      </div>
    </div>
  );
};

export default withTranslation()(withRouter(NotificationV2));
